import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';

export const ButtonTabContainer = styled.span`
  .invoice-button-tab {
    border-radius: 40px;
    font-size: 14px;
    font-weight: normal;
    margin-left: ${token('space.100')};
    background-color: ${token('color.background.neutral')};
    color: ${token('color.text.subtlest')} !important; // Override the default color
    &-active {
      background-color: ${token('color.background.selected')};
      color: ${token('color.text.selected')} !important; // Override the white color
    }
  }
`;
